module.exports = __webpack_public_path__ + "../resources/img/ic_module_portrait.6ceb23f9.svg";